import { render, staticRenderFns } from "./GoodsConfig.vue?vue&type=template&id=5f1402a2&scoped=true"
import script from "./GoodsConfig.vue?vue&type=script&lang=js"
export * from "./GoodsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1402a2",
  null
  
)

export default component.exports